module.exports = require('./helpers/bundle-url').getBundleURL('dwYZa') + "black_widow.803b452f.png";